import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import UBreadCrumbs from "../../components/mui/UBreadCrumbs";

import { API, PAGE } from "../../config";
import {
  fni18n,
  getAPI,
} from "../../services/commonService";
import AuthenticationService from "../auth/AuthenticationService";

import { theme } from "../../assets/themes";
import UTabs from "../../components/mui/UTabs";
import UAlertDialog from "../../components/mui/UAlertDialog";
import USelectBox from "../../components/mui/USelectBox";
import UTextField from "../../components/mui/UTextField";
import UPopupForm from "../../components/mui/UPopupForm";
import UButton from "../../components/mui/UButton";
import UTable from "../../components/mui/UTable";
import { makeStyles } from "@material-ui/core/styles";
import CloseUserPopUpPage from "./CloseUserPopUpPage";
import CloseMachinePopUpPage from "./CloseMachinePopUpPage";
import { useTranslation } from "react-i18next";

export default function SamplePage_Tab() {
  const { t } = useTranslation();
  const userLoginId = AuthenticationService.getLoggedInUserID();
  const columns = [
    {
      field: "id",
      headerName: "번호",
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "storeNm",
      headerName: "지점",
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "machineId",
      headerName: "기기번호",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "cashtype",
      headerName: "재화종류",
      headerAlign: "center",
      align: "center",
      hide: true,
    },
    {
      field: "open",
      headerName: "개시",
      headerAlign: "center",
      align: "center",
      colSpan: [
        {
          parentField: "open",
          field: "openDate",
          headerName: "일시",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {params.value}
              </div>
            );
          },
        },
        {
          parentField: "open",
          field: "openBalance",
          headerName: "잔액",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "open",
          field: "openJournal",
          headerName: "저널",
          editable: false,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => {
            if (params.rows.openJournal == null) {
              return "-";
            } else {
              return (
                <UButton
                  variant="outlined"
                  onButtonClick={(e) =>
                    handleJunlSelect(params.rows.openJournal)
                  }
                >
                  보기
                </UButton>
              );
            }
          },
        },
      ],
    },
    {
      field: "transaction",
      headerName: "거래",
      headerAlign: "center",
      align: "center",
      colSpan: [
        {
          parentField: "transaction",
          field: "totalDeposit",
          headerName: "입금",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "transaction",
          field: "totalDispense",
          headerName: "출금",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "transaction",
          field: "net",
          headerName: "소계",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
      ],
    },
    {
      field: "inventory",
      headerName: "시재",
      headerAlign: "center",
      align: "center",
      colSpan: [
        {
          parentField: "inventory",
          field: "addAmount",
          headerName: "보충",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "inventory",
          field: "removeAmount",
          headerName: "회수",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "inventory",
          field: "inventoryNet",
          headerName: "소계",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
      ],
    },
    {
      field: "close",
      headerName: "마감",
      headerAlign: "center",
      align: "center",
      colSpan: [
        {
          parentField: "close",
          field: "eodDate",
          headerName: "마감일시",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {params.value}
              </div>
            );
          },
        },
        {
          parentField: "close",
          field: "closeBalance",
          headerName: "잔액",
          editable: false,
          align: "center",
          headerAlign: "center",
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
        {
          parentField: "close",
          field: "closeJournal",
          headerName: "저널",
          editable: false,
          headerAlign: "center",
          align: "center",
          renderCell: (params) => {
            if (params.rows.closeJournal == null) {
              return "-";
            } else {
              return (
                <UButton
                  variant="outlined"
                  onButtonClick={(e) =>
                    handleJunlSelect(params.rows.closeJournal)
                  }
                >
                  보기
                </UButton>
              );
            }
          },
        },
      ],
    },
    //리젝함 금액
    {
      field: 'rejtAmnt',
      headerName: '리젝함',
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    //봉투입금함 금액
    {
      field: 'envelopeAmnt', 
      headerName: '봉투입금함',
      // width: 40,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    //보회함 금액
    {
      field: 'transitcstAmnt', 
      headerName: '보회함',
      // width: 40,
      editable: false,
      align: "center",
      headerAlign: "center",
    },
    //리젝함 불명권 매수
    {
      field: 'rejtUnkcnt', 
      headerName: '리젝함 불명권 매수',
      // width: 40,
      editable: false,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params)=>{
          if (params.value > 0) {
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "red",
                }}
              >
                {params.value}
              </div>
            );
          }
          return params.value;
      }
    },
    {
      field: "difference",
      headerName: "차액",
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) => {
        if (params.value === ('$ 0')) {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {params.value}
            </div>
          );
        } else if (params.value.startsWith('-$')) {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "red",
              }}
            >
              {params.value}
            </div>
          );
        } else if (params.value.startsWith('$')) {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "red",
              }}
            >
              {params.value}
            </div>
          );
        } else {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              -
            </div>
          );
        }
      },
    },
  ];
  const hist_columns = [
    {
      field: "tab_id",
      headerName: "번호",
      headerAlign: "center",
      align: "center",
      hide: true,
      id: 16,
    },
    {
      field: "userId",
      headerName: "사원번호",
      width: "12.5%",
      headerAlign: "center",
      align: "center",
      id: 18,
    },
    {
      field: "userName",
      headerName: "사원명",
      width: "12.5%",
      headerAlign: "center",
      align: "center",
      id: 19,
    },
    {
      field: "deposit",
      headerName: "총 입금",
      width: "25%",
      headerAlign: "center",
      align: "center",
      id: 20,
      colSpan: [
        {
          parentField: "deposit",
          field: "lastIn",
          headerName: "최종 입금일",
          width: "12.5%",
          editable: false,
          align: "center",
          headerAlign: "center",
          id: 21,
        },
        {
          parentField: "deposit",
          field: "inTotAmt",
          headerName: "입금 총 금액",
          width: "12.5%",
          editable: false,
          align: "center",
          headerAlign: "center",
          id: 22,
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
      ],
    },
    {
      field: "dispense",
      headerName: "총 출금",
      width: "25%",
      headerAlign: "center",
      align: "center",
      id: 23,
      colSpan: [
        {
          parentField: "dispense",
          field: "lastOut",
          headerName: "최종 출금일",
          width: "12.5%",
          editable: false,
          align: "center",
          headerAlign: "center",
          id: 24,
        },
        {
          parentField: "dispense",
          field: "outTotAmt",
          headerName: "출금 총 금액",
          width: "12.5%",
          editable: false,
          align: "center",
          headerAlign: "center",
          id: 25,
          valueFormatter: (params) => {
            if (params.value.startsWith('-$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  {params.value}
                </div>
              );
            } else if (params.value.startsWith('$')) {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {params.value}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  -
                </div>
              );
            }
          },
        },
      ],
    },
    {
      field: "net",
      headerName: "누계",
      width: "12.5%",
      headerAlign: "center",
      align: "center",
      valueFormatter: (params) => {
        if (params.value.startsWith('-$')) {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "red",
              }}
            >
              {params.value}
            </div>
          );
        } else if (params.value.startsWith('$')) {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {params.value}
            </div>
          );
        } else {
          return (
            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              -
            </div>
          );
        }
      },
      id: 26,
    },
    {
      field: "button",
      headerName: "상세",
      sortable: false,
      width: "12.5%",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <UButton
          variant="outlined"
          onButtonClick={() => handleRowSelect(params.rows)}
        >
          보기
        </UButton>
      ),
      id: 27,
    },
  ];
  const useStyles = makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: "1px solid #EAEAEA",
        borderTop: "1px solid #EAEAEA",
      },
    },
    header: {
      fontWeight: "bold",
      "& .MuiTableCell-root": {
        // width:195,
      },
    },
    cellTitle: {
      backgroundColor: theme.custom.appbarBgColor,
    },
    cell: {
      padding: 5,
    },
  });
  const [stores, setStore] = useState([]);
  const [brands, setBrands] = useState([]);
  const [machineNo, setMachineNo] = useState([]);

  const [formOpen, setFormOpen] = useState(false);
  const [popUpParamas, setPopUpParams] = useState({});

  const date = new Date();
  const now = date.toISOString().slice(0, 10);
  const [search, setSearch] = useState({
    // store: stores,
    // brandCd: brands,
    // machineNo: machineNo,
    // userId: "",
    startDate: now,
  });
  const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
  const [errorMsg, setErrorMsg] = useState(""); // api error message

  const [list, setList] = useState([]);
  const [tabList, setTabList] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [junlData, setJunlData] = useState();
  const [junlOpen, setJunlOpen] = useState(false);
  const [retailers, setRetailers] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [permission, setPermission] = useState();
  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await Promise.all([
          loadComboBoxBranchGroup(),
          loadComboBoxBranch(),
          loadPermission()
        ]);
      } catch (e) {
        console.error('초기 로딩 실패:', e.message);
      }
    };
    getLoadData();
  }, []);

  // useEffect(() => {
  //   onButtonClick("조회");
  // }, [permission]);

  // useEffect(() => {
  //   onButtonClick("조회");
  // }, [tabIndex]);

  useEffect(() => {
    if (!isFirstLoad) return;
    if (permission && tabIndex === 0 && search.storeCd) {
      onButtonClick("조회");
      setIsFirstLoad(false);
    }
  }, [permission, tabIndex, search]);

  const clearSearchVal = ()=>{
    setSearch({
      ...search,
      ['storeCd']: 'N/A',
    });
    setMachineNo([]);
    setBrands([]);
  }

  // 콤보박스 데이터
  const loadComboBoxBranchGroup = async () => {
      try {
          const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
          const _inputData = res.data.result.map((m) => ({
              cd: m.id,
              name: m.branchGroupNm,
          }));
          setRetailers(_inputData);
          // await loadComboBoxBranch(_inputData[0].cd);
      } catch (e) {
          console.error(e.message);
      }
  };
  const loadComboBoxBranch = async (param) => {
    try {
      const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeNm,
      }));
      setStore(_inputData);
      if (_inputData.length > 0) {
        await loadComboBoxBrand(_inputData[0].cd);
        await loadComboBoxMachineNo(_inputData[0].cd);
      } else {
        clearSearchVal()
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  const loadComboBoxBrand = async (branch) => {
    try {
      const res = await getAPI(API.COMMON.BRAND, {
        userId: userLoginId,
        branch: branch,
      });
      const _inputData = res.data.result.map((m) => ({
        cd: m.brandCd,
        name: m.brandNm,
      }));
      if (_inputData.length > 0) {
        setSearch({
          ...search,
          ["brandCd"]: _inputData[0].cd,
          ["storeCd"]: branch,
        });
      } else {
        setSearch({
          ...search,
          ["brandCd"]: "N/A",
          ["storeCd"]: branch,
        });
      }
      setBrands(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };

  const loadComboBoxMachineNo = async (store) => {
    try {
      const res = await getAPI(API.COMMON.MACHINE + store);
      const _inputData = res.data.result.map((m) => ({
        cd: m.machId,
        name: m.machId,
      }));
      setMachineNo(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };

  const loadPermission = async () => {
    try {
      const res = await getAPI(API.COMMON.PERMISSION, { userId: userLoginId });
      setPermission(res.data);
    } catch (e) {
      console.error(e.message);
    }
  };

  const handleErrorOpen = () => {
    setErrorPopupOpen(true);
  };
  const handleErrorClose = () => {
    setErrorPopupOpen(false);
  };

  //DataGrid에서 row 선택 시
  function onSelectedRow(e, row) {}

  const onSelectedRows = (e, row) => {};

  function changeTabPage(index) {
    setTabIndex(index);
  }

  //검색조건 값 변경되었을 때
  const onSearchChange = async (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value === "ALL" ? "" : value,
    });
    if (name === "bizTy") {
      loadComboBoxBranch(value);
    }
    //지점선택 후 기번 가져오기
    if (name === "storeCd") {
      loadComboBoxMachineNo(value);
      loadComboBoxBrand(value);
    }
  };

  const handleRowSelect = (row) => {
    setPopUpParams({
      userId: row.userId,
      storeCd: row.storeCd,
      date: search.startDate,
    });
    handleFormOpen();
  };

  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };

  const handleJunlSelect = (data) => {
    setJunlData({
      jnul: data,
    });
    setJunlOpen(true);
  };

  const handleJunlOpen = () => {
    setJunlOpen(true);
  };
  const handleJunlClose = () => {
    setJunlOpen(false);
  };

  async function onButtonClick(dvsn) {
    if (dvsn === "조회") {
      try {
        if (tabIndex == 0) {
          const res = await getAPI(API.CASH.CLOSE_DAILY, search);
          if (res.data.code === 200) {
            const _inputData = res.data.result.map((rowData) => ({
              id: rowData.no,
              machineId: rowData.machId,
              openDate: rowData.openDate,
              openBalance: isNaN(rowData.openBalance)?"-":rowData.openBalance>=0?"$ "+Number(rowData.openBalance).toLocaleString("en-US"):"-$ "+Number(rowData.openBalance*-1).toLocaleString("en-US"),
              openJournal: rowData.openJrnl,
              totalDeposit: isNaN(rowData.deposit)?"-":rowData.deposit>0?"$ "+Number(rowData.deposit).toLocaleString("en-US"):rowData.dispense<0?"-$ "+Number(rowData.deposit*-1).toLocaleString("en-US"):"-",
              totalDispense: isNaN(rowData.dispense)?"-":rowData.dispense>0?"$ "+Number(rowData.dispense).toLocaleString("en-US"):rowData.dispense<0?"-$ "+Number(rowData.dispense*-1).toLocaleString("en-US"):"-",
              net: isNaN(rowData.net)?"-":rowData.net>=0?"$ "+Number(rowData.net).toLocaleString("en-US"):"-$ "+Number(rowData.net*-1).toLocaleString("en-US"),
              eodDate: rowData.closeDate,
              closeBalance: isNaN(rowData.closeBalance)?"-":rowData.closeBalance>=0?"$ "+Number(rowData.closeBalance).toLocaleString("en-US"):"-$ "+Number(rowData.closeBalance*-1).toLocaleString("en-US"),
              closeJournal: rowData.closeJrnl,
              rejtAmnt: isNaN(rowData.rejtAmnt)?"-":rowData.rejtAmnt>=0?"$ "+Number(rowData.rejtAmnt).toLocaleString("en-US"):"-$ "+Number(rowData.rejtAmnt*-1).toLocaleString("en-US"),
              rejtUnkcnt: rowData.rejtUnkcnt,
              envelopeAmnt: isNaN(rowData.envelopeAmnt)?"-":rowData.envelopeAmnt>=0?"$ "+Number(rowData.envelopeAmnt).toLocaleString("en-US"):"-$ "+Number(rowData.envelopeAmnt*-1).toLocaleString("en-US"),
              transitcstAmnt: isNaN(rowData.transitcstAmnt)?"-":rowData.transitcstAmnt>=0?"$ "+Number(rowData.transitcstAmnt).toLocaleString("en-US"):"-$ "+Number(rowData.transitcstAmnt*-1).toLocaleString("en-US"),
              difference: isNaN(rowData.diff)||rowData.closeBalance=="-"?"-":rowData.diff>=0?"$ "+Number(rowData.diff).toLocaleString("en-US"):"-$ "+Number(rowData.diff*-1).toLocaleString("en-US"),
              removeAmount: isNaN(rowData.removeAmount)?"-":rowData.removeAmount>0?"$ "+Number(rowData.removeAmount).toLocaleString("en-US"):rowData.removeAmount<0?"-$ "+Number(rowData.removeAmount*-1).toLocaleString("en-US"):"-",
              addAmount: isNaN(rowData.addAmount)?"-":rowData.addAmount>0?"$ "+Number(rowData.addAmount).toLocaleString("en-US"):rowData.addAmount<0?"-$ "+Number(rowData.addAmount*-1).toLocaleString("en-US"):"-",
              inventoryNet: isNaN(rowData.inventoryNet)?"-":rowData.inventoryNet>=0?"$ "+Number(rowData.inventoryNet).toLocaleString("en-US"):"-$ "+Number(rowData.inventoryNet*-1).toLocaleString("en-US"),
            }));
            setList(_inputData);
          } else {
            setErrorMsg(t("처리가 실패하였습니다"));
            handleErrorOpen();
            setList([]);
          }
        } else if (tabIndex == 1) {
          const res = await getAPI(API.CASH.CLOSE_USER, search);
          if (res.data.code === 200) {
            const _inputData = res.data.result.map((rowData) => ({
              id: rowData.no,
              userId: rowData.userId,
              storeCd: rowData.storeCd,
              userName: rowData.userName,
              transactionDate: rowData.trnsctDt,
              lastIn: rowData.lastIn,
              inTotAmt: isNaN(rowData.inTotAmt)?"-":rowData.inTotAmt>=0?"$ "+Number(rowData.inTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.inTotAmt*-1).toLocaleString("en-US"),
              lastOut: rowData.lastOut,
              outTotAmt: isNaN(rowData.outTotAmt)?"-":rowData.outTotAmt>=0?"$ "+Number(rowData.outTotAmt).toLocaleString("en-US"):"-$ "+Number(rowData.outTotAmt*-1).toLocaleString("en-US"),
              net: isNaN(rowData.net)?"-":rowData.net>=0?"$ "+Number(rowData.net).toLocaleString("en-US"):"-$ "+Number(rowData.net*-1).toLocaleString("en-US"),
            }));
            setTabList(_inputData);
          } else {
            setErrorMsg(t("처리가 실패하였습니다"));
            handleErrorOpen();
            setTabList([]);
          }
        }
      } catch (e) {
        console.error(e.message);
      }
    } else {
      setErrorMsg(t("알 수 없는 오류가 발생하였습니다"));
      handleErrorOpen();
    }
  }

  return (
    <div className="main-container">
      <Box className="header">
        <Grid container>
          <Grid item xs={12}>
            {/* 상단메뉴명 */}
            <UBreadCrumbs title={"자금정보"} subtitle={"마감현황"} />
          </Grid>
        </Grid>
      </Box>

      <div className="contents">
        <Box>
          <TableContainer className="table-container">
            <Table className="table" size="small">
              <TableBody>
                <TableRow className="table-row-header">
                  <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                  <TableCell className="table-cell">
                      <USelectBox
                          name="bizTy"
                          items={retailers}
                          onItemChange={onSearchChange}
                      />
                  </TableCell>
                  <TableCell className="table-cell-title">{fni18n("지점")}</TableCell>
                  <TableCell className="table-cell">
                    {/* 선택 */}
                    <USelectBox
                      name="storeCd"
                      items={stores}
                      onItemChange={onSearchChange}
                      defaultValue={search.storeCd}
                    />
                  </TableCell>
                  {tabIndex == 0 && (
                    <TableCell className="table-cell-title">{fni18n("기기번호")}</TableCell>
                  )}
                  {tabIndex == 0 && (
                    <TableCell className="table-cell">
                      {/* 기번선택 */}
                      <USelectBox
                        id="machineNo"
                        name="machineNo"
                        items={machineNo}
                        onItemChange={onSearchChange}
                      />
                    </TableCell>
                  )}
                  {tabIndex == 1 && (
                    <TableCell className="table-cell-title">{fni18n("브랜드")}</TableCell>
                  )}
                  {tabIndex == 1 && (
                    <TableCell className="table-cell">
                      {/* 브랜드 선택 */}
                      <USelectBox
                        id="brandCd"
                        name="brandCd"
                        items={brands}
                        onItemChange={onSearchChange}
                        defaultValue={search.brandCd}
                      />
                    </TableCell>
                  )}
                  <TableCell className="table-cell-title">{fni18n("일자")}</TableCell>
                  <TableCell className="table-cell">
                    {/* 날짜선택 */}
                    <FormControl sx={{ width: 150 }}>
                      <TextField
                        name="startDate"
                        type="date"
                        size="small"
                        defaultValue={now}
                        variant="outlined"
                        id="outlined-basic"
                        onChange={onSearchChange}
                        inputProps={{ style: { fontSize: 13 } }} // font size of input text
                        />
                    </FormControl>
                  </TableCell>
                        {tabIndex == 1 && (
                          <TableCell className="table-cell-title">{fni18n("사원번호")}</TableCell>
                        )}
                        {tabIndex == 1 && (
                          <TableCell className="table-cell">
                            {/* 사용자 */}
                            <UTextField name="userId" onChange={onSearchChange} />
                          </TableCell>
                        )}
                  {tabIndex == 0 && (
                    <TableCell className="table-cell"></TableCell>
                  )}
                  {tabIndex == 0 && (
                    <TableCell className="table-cell"></TableCell>
                  )}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div className="search">
            <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
          </div>
        </Box>
        {permission == undefined && (
          <UTable
            tablabel={fni18n("기기마감")}
            columns={columns}
            rows={list}
            rowPerPage={11}
            onSelectedRowChange={onSelectedRows}
          />
        )}
        {permission == "STORE" && (
          <UTable
            tablabel={fni18n("기기마감")}
            columns={columns}
            rows={list}
            rowPerPage={11}
            onSelectedRowChange={onSelectedRows}
          />
        )}
        {(permission != "STORE" && permission != undefined) && (
          <UTabs onSelectedRow={onSelectedRow} onChangeTab={changeTabPage}>
            <UTable
              tablabel={fni18n("기기마감")}
              columns={columns}
              rows={list}
              rowPerPage={10}
              onSelectedRowChange={onSelectedRows}
            />
            <UTable
              tablabel={fni18n("사용자마감")}
              columns={hist_columns}
              rows={tabList}
              rowPerPage={10}
              onSelectedRowChange={onSelectedRows}
            />
          </UTabs>
        )}
        <UPopupForm
          open={formOpen}
          onClose={handleFormClose}
          title={"상세"}
          type={"1"}
          content={<CloseUserPopUpPage data={popUpParamas} />}
          maxWidth={"xl"}
        />
        <UPopupForm
          open={junlOpen}
          onClose={handleJunlClose}
          title={"저널"}
          type={"1"}
          content={<CloseMachinePopUpPage data={junlData} />}
        />
      </div>
      <UAlertDialog
        message={errorMsg}
        open={errorPopupOpen}
        onClose={handleErrorClose}
      />
    </div>
  );
}
